/**
 * Checks for a valid src path, if none passed, will show default.
 * If image fails to load, it will show default.
 * Fallback image is set inline with directive
 * v-image-fall-back="imgFallback"
 */
export default {
    mounted(el, binding) {

        const { value } = binding; // fall back image
        const fallBackImage = value;
        const original = el.src;

        if( !original || !original.length ) {
            return el.src = fallBackImage;
        }

        el.onerror = () => {
            el.src = fallBackImage;
        };
    }
}